/**
 * Gates for ACTIONS (not pages). Guests browse and upload freely.
 *
 * - requireSignIn: needs *a session* (an anonymous guest session is enough).
 *   Used before uploading a photo. A guest session is created in the background
 *   when the editor opens, so this is normally already satisfied.
 * - requireAccount: needs a real account (email sign-in). Used before anything
 *   that spends credits. Opens an in-page sheet instead of navigating away, so
 *   the photo the user already uploaded stays on screen.
 */
import { toast } from '../ui/toast.js';
import { openSignInSheet } from '../ui/signinSheet.js';
import { ensureGuestSession, hasAccount, isAuthed } from './auth.js';

export function requireSignIn(reason: string): boolean {
  if (isAuthed()) return true;
  void ensureGuestSession();
  toast(reason);
  return false;
}

export function requireAccount(reason: string): boolean {
  if (hasAccount()) return true;
  openSignInSheet(reason);
  return false;
}
